import React, { createContext, useContext } from 'react';
import { useEventMessages } from '../Hooks/useEventMessages';
import { useDataContext } from './useDataContext';
import { PushMessageModal } from '../Components/PushMessageModal';
import type { EventPushMessage } from '@moment-golf/types';

interface MessageContextType {
    activeMessages: EventPushMessage[];
    isAcknowledged: (pushedAt: string) => boolean;
    reviewMessage: EventPushMessage | null;
    openReview: (pushedAt: string) => void;
    closeReview: () => void;
}

const MessageContext = createContext<MessageContextType | null>(null);

export const MessageProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const { eventData, scoreCode, registrationData } = useDataContext();

    const {
        activeMessages,
        pendingMessages,
        acknowledge,
        isAcknowledged,
        reviewMessage,
        openReview,
        closeReview,
    } = useEventMessages(
        eventData?._id,
        scoreCode,
        registrationData ?? [],
    );

    return (
        <MessageContext.Provider value={{
            activeMessages,
            isAcknowledged,
            reviewMessage,
            openReview,
            closeReview,
        }}>
            {children}
            {eventData?._id && (
                <PushMessageModal
                    pendingMessages={pendingMessages}
                    reviewMessage={reviewMessage}
                    acknowledge={acknowledge}
                    closeReview={closeReview}
                />
            )}
        </MessageContext.Provider>
    );
};

export const useMessageContext = (): MessageContextType => {
    const ctx = useContext(MessageContext);
    if (!ctx) throw new Error('useMessageContext must be used within a MessageProvider');
    return ctx;
};
